import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import type { BeniSmartCompset } from 'lumen/models';
import type HotelSettingsCompetitorsBenchmarkRoute from 'lumen/routes/hotel/settings/competitors/benchmark';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsCompetitorsBenchmarkSmartCompsetController extends Controller {
  declare model: ModelFrom<HotelSettingsCompetitorsBenchmarkRoute>;

  @service declare router: Services['router'];

  get smartCompset(): BeniSmartCompset | null {
    return this.model.smartCompset.last?.value ?? null;
  }

  @action
  onCloseModal(): void {
    this.router.transitionTo('hotel.settings.competitors.benchmark');
  }
}
